import React, { useEffect, useRef, useState } from "react";
import dispositivoServicio from "../../services/dispositivo/dispositivoService";
import { IPaginacion } from "../../Interfaces/filter";
import { IDispositivo } from "../../Interfaces/IDispositivos";
import { IException } from "../../Interfaces/base/IBase";
import { ISearchBox } from "@fluentui/react";
import {
  IFilterDispositivoHistorico,
  IFilterReporteDispositivoHistorico,
  InitialFilterDispositivoHistorico,
  InitialFilterReporte,
} from "../../Interfaces/DispositivoAsignado/IDispositivoAsignado";
import { isUnionTypeNode } from "typescript";
import { _formatDate } from "../../utils/helpers/dateHelpers";
interface IFilterFechasDate {
  filterFechaInicio: Date | undefined;
  filterFechaFin: Date | undefined;
}
export const useTableDispositivoHistorico = () => {
  const controllerRef = useRef<AbortController>(new AbortController());
  const [itemsDsp, setItemsDsp] = useState<IDispositivo[]>([]);
  const [control, setControl] = useState(false)
  const [filterTable, setFilterTable] = useState<IFilterDispositivoHistorico>(
    InitialFilterDispositivoHistorico
  );
  const [filterFechas, setFilterFechas] = useState<IFilterFechasDate>({
    filterFechaInicio: undefined,
    filterFechaFin: new Date(),
  });
  const [filterReporte, setFilterReporte] =
    useState<IFilterReporteDispositivoHistorico>(InitialFilterReporte);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [loading, setLoading] = useState(false);

  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearchDispositivo = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilterTable({ ...filterTable, search: value });
  };

  const getDataTable = () => {
    controllerRef.current.abort();
    const newController = new AbortController();
    controllerRef.current = newController;
    setLoading(true);
    dispositivoServicio
      .postTableHistoricoDispositivo(filterTable, newController)
      .then((res) => {
        if (res.status === 200) {
          setItemsDsp(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
        console.log(err);
      });
  };
  const onSelectDate = (date: Date | null | undefined, text: string) => {
    if (date) {
      switch (text) {
        case "inicio":
          setFilterFechas({ ...filterFechas, filterFechaInicio: date, filterFechaFin: date > (filterFechas.filterFechaFin as Date) ? date : filterFechas.filterFechaFin });
          setFilterTable({
            ...filterTable,
            fechaInicio: _formatDate(date, ","),
            fechaFin: date > (filterFechas.filterFechaFin as Date) ? _formatDate(date, ",") : _formatDate(filterFechas.filterFechaFin as Date, ","),
          });
          setFilterReporte({
            ...filterReporte,
            fechaInicio: _formatDate(date, ","),
          });
          break;
        case "fin":
          setFilterFechas({ ...filterFechas, filterFechaFin: date });
          setFilterTable({
            ...filterTable,
            fechaFin: _formatDate(date, ","),
          });
          setFilterReporte({
            ...filterReporte,
            fechaFin: _formatDate(date, ","),
          });
          break;
        default:
          break;
      }
    }
  };
  const onChangeComboBox = (e, o, text) => {
    if (e !== undefined) {
      switch (text) {
        case "guardia":
          if (o?.key) {
            setFilterTable({ ...filterTable, guardia: o.key });
            setFilterReporte({
              ...filterReporte,
              guardia: o.key,
            });
          }
          break;
        case "area":
          if (o?.key) {
            setFilterTable({ ...filterTable, areaId: o.key });
            setFilterReporte({
              ...filterReporte,
              areaId: o.key,
            });
          }
          break;
        default:
          break;
      }
    }
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilterTable({ ...filterTable, skip: filterTable.skip + 1 });
        break;
      case "prev":
        setFilterTable({ ...filterTable, skip: filterTable.skip - 1 });
        break;

      default:
        break;
    }
  };

  const limpiarFiltro = () => {
    setFilterTable(InitialFilterDispositivoHistorico);
    setFilterReporte(InitialFilterReporte);
    setFilterFechas({
      ...filterFechas,
      filterFechaInicio: undefined,
      filterFechaFin: new Date(),
    });
    setControl(true)
  };

  const Actualizar = () => {
    getDataTable();
  };

  useEffect(() => {
    if (control) {
      getDataTable();
      setControl(false)
    }
  }, [control])

  return {
    getDataTable,
    searchBoxRefTable,
    _onkeyUpSearchDispositivo,
    paginacion,
    itemsDsp,
    loading,
    onChangeSkip,
    onChangeComboBox,
    onSelectDate,
    limpiarFiltro,
    filterFechas,
    filterReporte,
    Actualizar
  };
};
